const TreeNodeType = {
    FILE: 'file',
    FOLDER: 'folder'
};

export default TreeNodeType;
